import templateUrl from './edit-icd-corporation.component.html'
import { ILogService, IQService, ITimeoutService } from 'angular';
import { UtilityService } from '../../../core/services/utility.service';
import { getExceptionMessage } from '../../../core/data-utils';

export const EditIcdCorporationComponent = {
    templateUrl,
    controller: EditIcdCorporationController,
    controllerAs: "vm",
    bindings: {
        icdCorporationID: "<?icdCorporationId",
        required: "<?"
    },
}

function EditIcdCorporationController(
    $log: ILogService,
    $q: IQService,
    $timeout: ITimeoutService,
    auditorService,
    hubService,
    icdCorporationService,
    icdOfficeService,
    payrollInvoicePolicyService,
    stateProvinceService,
    utilityService: UtilityService) {
    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;

    vm.icdCorporationID;
    vm.icdCorporation;
    vm.companyLogoFiles;
    vm.companyLogo = {};
    vm.hub;
    vm.hubOptions = [];
    vm.icdCorporationAuditors; // Selected auditors for the corporation.
    vm.auditors;
    vm.auditorOptions = [];
    vm.payrollInvoicePolicies;
    vm.ModuleOptions = [];
    vm.icdtaxinfoTypes = [{ Name: "State Income Tax", Key: "State Income Tax" }, { Name: "State Unemployment Insurance", Key: "State Unemployment Insurance" }, { Name: "Local", Key: "Local" }];
    vm.onSubmit = onSubmit;
    vm.statusOptions = [];
    vm.insurePayOptions = [
        { Name: "True", Value: 1 },
        { Name: "False", Value: 0 }
    ];
    vm.handleCompanyLogoFileSelected = handleCompanyLogoFileSelected;
    vm.clearCompanyLogoUpload = clearCompanyLogoUpload;
    vm.addNewAuditor = addNewAuditor;
    vm.deleteAuditor = deleteAuditor;
    vm.getCompanyLogo = getCompanyLogo;
    vm.getHubs = getHubs;
    vm.getPayrollInvoicePolicies = getPayrollInvoicePolicies;
    vm.getIcdModules = getIcdModules;
    vm.moduleToggleSelection = moduleToggleSelection;
    vm.getIcdCorporationStatus = getIcdCorporationStatus;
    //vm.validateTaxInfo = validateTaxInfo;
    vm.corporationStatusEnum = {
        Active: 1,
        Inactive: 2
    };
    vm.icdtaxinfo = [];
    vm.addicdtaxinfo = addicdtaxinfo;
    vm.removeicdtaxinfo = removeicdtaxinfo;
    vm.saveicdtaxinfo = saveicdtaxinfo;
    vm.validTaxInfo = false;
    vm.useHJFees = false;
    function addicdtaxinfo() {
        vm.icdtaxinfo.push({ IcdCorporationTaxInfoID: null, Name: '', Value: '', State: '', CorporationID: vm.icdCorporationID });
    };

    function removeicdtaxinfo(index) {
        vm.icdtaxinfo.splice(index, 1);
    };


    //function validateTaxInfo() {
    //    let validate = vm.icdtaxinfo.some((item, index, self) => {
    //        return self.findIndex(p => p.CorporationID === item.CorporationID && p.State === item.State && p.Name === item.Name) !== index;
    //    });
    //    this.editForm.icdtaxinfo.$setValidity("invalid", !validate)
    //}





    function onInit() {
        window.onbeforeunload = onBeforeUnload;
        utilityService.showLoading();
        vm.required = true;
        refreshScreen().catch(function (ex) {
            $log.error(ex);
            alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
        }).then(function () {
            utilityService.hideLoading();
        });
    }




    function refreshScreen() {
        const loadIcdCorporationData = $q.all([vm.icdCorporationID])
            .then(function (v) {
                // Load all of the resolved data into the controller.
                return loadIcdCorporation();
            });

        const loadStateProvinces = stateProvinceService.retrieveStateProvinces()
            .then(function (stateProvinces) {
                vm.stateProvinces = stateProvinces;
                //console.log(stateProvinces);
            });

        return $q.all([loadIcdCorporationData, loadStateProvinces,
            getCompanyLogo().then(function (companyLogo) {
                vm.companyLogo = companyLogo;
            }),
            getHubs().then(function (hubs) {
                vm.hubOptions = hubs;
            }),
            getPayrollInvoicePolicies().then(function (policies) {
                vm.payrollInvoicePolicies = policies;
            }),
            loadIcdCorporationAuditors(vm.icdCorporationID).then(function (auditors) {
                vm.icdCorporationAuditors = auditors;
            }),
            getIcdModules().then(function (modules) {
                vm.Modules = modules;
            }),
            getIcdCorporationStatus().then(function (statusOptions) {
                vm.statusOptions = statusOptions;
            }),
            loadAllAuditors().then(function (auditors) {
                vm.auditorOptions = auditors;
            }),
            loadIcdOffices().then(function (icdOffices) {
                vm.icdOffices = icdOffices;
            }),
            handleAuditorDataSourceRead()
        ]).then(function (result) {
            return result;
        });
    }

    function onSubmit() {

        console.log(vm.icdCorporation.InsurePay.Value);
        //icd tax info
        let data = vm.icdtaxinfo.map(function (e) {
            let newObject = {};
            newObject["Name"] = e.name.Name;
            newObject["State"] = e.state.StateProvinceID;
            newObject["Value"] = e.Value;
            newObject["IcdCorporationID"] = e.CorporationID;
            if (e.IcdCorporationTaxInfoID !== 0 && e.IcdCorporationTaxInfoID !== null) {
                newObject["IcdCorporationTaxInfoID"] = e.IcdCorporationTaxInfoID;
            }
            return newObject;
        })

        let validate = data.some((item, index, self) => {
            return self.findIndex(p => p.CorporationID === item.CorporationID && p.State === item.State && p.Name === item.Name) !== index;
        });
        if (validate) {
            alert('Company Tax Information Duplicate Found.');
            return;
        }
        let save;
        if (vm.payrollInvoicePolicyID) {
            vm.icdCorporation.PayrollInvoicePolicyID = vm.payrollInvoicePolicyID;
        } else {
            vm.icdCorporation.PayrollInvoicePolicyID = null;
        }

        if (vm.ModuleOptions.length > 0) {
            vm.icdCorporation.Modules = vm.ModuleOptions;
        }

        vm.icdCorporation.InsurePay = vm.icdCorporation.InsurePay.Value;

        if (vm.companyLogo) {
            if (vm.companyLogo.dataUrl) {
                const splitedUrl = vm.companyLogo.dataUrl.split(",");
                vm.icdCorporation.CompanyLogo = vm.companyLogo;
                vm.icdCorporation.CompanyLogo.OriginalFileName = vm.companyLogo.originalFileName;
                vm.icdCorporation.CompanyLogo.ImageData = splitedUrl[1];
                vm.icdCorporation.CompanyLogo.MimeType = splitedUrl[0].substring(splitedUrl[0].indexOf(":") + 1, splitedUrl[0].indexOf(";"));
            }
        }

        vm.icdCorporation.Auditors = vm.icdCorporationAuditors;
        vm.icdCorporation.HasHJFees = vm.useHJFees;
        vm.corp = null;
        if (vm.icdCorporation.Id) {
            save = icdCorporationService.updateIcdCorporationService(vm.icdCorporation.Id, vm.icdCorporation);
        } else {
            save = icdCorporationService.createIcdCorporationService(vm.icdCorporation);
        }
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(save, "Save failed"));

        const refreshed = save.catch(() => { }).then((res) => {
            if (!vm.icdCorporation.Id) {
                vm.corp = res;
            } else {
                vm.corp = vm.icdCorporation.Id;
            }
            return icdCorporationService.updateIcdTaxInfoService(vm.corp, data);
        }).then(function (response) {
            if (!response) {
                return;
            }
            return icdCorporationService.retrieveIcdCorporationTaxInfo(vm.corp);
        }).then(function (response) {
            if (!response) {
                return;
            }

            vm.editForm.$setPristine(true); // Prevent onbeforeunload.

            if (!vm.icdCorporation.Id) {
                if (vm.icdCorporation.IcdCorporationStatusID === vm.corporationStatusEnum.Inactive) {
                    window.location.href = "Organization/EditIcdCorporation/" + vm.corp;
                } else {
                    window.location.href = "Organization/EditICDOffice?icdCorporationID=" + vm.corp;
                }
            } else {
                return refreshScreen();
            }
        });

        utilityService.showLoadingUntilResolved(utilityService.alertOnError(
            refreshed, "Save was successful, but reloading data failed. Please refresh the page manually. Error"));
    }

    function saveicdtaxinfo() {
        let save;
        //let data = vm.icdtaxinfo.map(function (e) {
        //    let newObject = {};
        //    newObject["Name"] = e.name.Name;
        //    newObject["State"] = e.state.StateProvinceID;
        //    newObject["Value"] = e.Value;
        //    newObject["IcdCorporationID"] = e.CorporationID;
        //    if (e.IcdCorporationTaxInfoID !== 0 && e.IcdCorporationTaxInfoID !== null) {
        //        newObject["IcdCorporationTaxInfoID"] = e.IcdCorporationTaxInfoID;
        //    }
        //    return newObject;
        //})

        //let validate = data.some((item, index, self) => {
        //    return self.findIndex(p => p.CorporationID === item.CorporationID && p.State === item.State && p.Name === item.Name) !== index;
        //});

        //if (validate) {
        //    alert('Company Tax Information Duplicate Found.');
        //    return;
        //}



        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(save, "Save failed"));

        const refreshed = save.catch((err) => {
            utilityService.hideLoading();
            console.log(err);
            return;

        }).then(function (response) {
            if (!response) {
                return;
            }
            return icdCorporationService.retrieveIcdCorporationTaxInfo(vm.icdCorporation.Id);
        }).then(function (data) {
            console.log(data);
            vm.editForm.$setPristine(true); // Prevent onbeforeunload.
        });

        utilityService.showLoadingUntilResolved(utilityService.alertOnError(
            refreshed, "Save was successful, but reloading data failed. Please refresh the page manually. Error"));
    };

    function handleCompanyLogoFileSelected() {

        if (!vm.companyLogoFiles) {
            vm.clearCompanyLogoUpload();
            return;
        }
        const file = vm.companyLogoFiles;

        vm.companyLogo.file = file;
        vm.companyLogo.originalFileName = file.name;

        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = function (e) {
            $timeout(function () {

                vm.companyLogo.dataUrl = e.target.result;
            });
        };
    }

    function handleAuditorDataSourceRead() {

        const selectedAuditors = loadIcdCorporationAuditors(vm.icdCorporationID);

        const allAuditors = loadAllAuditors();

        $q.all([allAuditors, selectedAuditors])
            .then(function (v) {
                const allAuditors = v[0];
                const selectedAuditors = v[1];
                // Only include auditors that are not already in the list.
                vm.auditorOptions = allAuditors.filter(function (auditor) {
                    return selectedAuditors.filter(function (selectedAuditor) {
                        return auditor.Id === selectedAuditor.Id;
                    }).length === 0;
                });
            })
    }

    function clearCompanyLogoUpload() {
        delete vm.companyLogo.file;
        delete vm.companyLogo.originalFileName;
        delete vm.companyLogo.dataUrl;
    }

    function loadIcdCorporationAuditors(icdCorporationID) {
        if (vm.icdCorporationAuditors !== undefined) {
            return $q.when(vm.icdCorporationAuditors)
        }

        if (!icdCorporationID) {
            return $q.when([]);
        } else {
            return icdCorporationService.retrieveIcdCorporationAuditors(icdCorporationID);
        }
    }

    function loadAllAuditors() {
        if (vm.auditors !== undefined) {
            return $q.when(vm.auditors);
        }

        return auditorService.retrieveAuditors()
            .then(function (auditors) {
                // Assign a Text and Value field to each hub.
                for (let i = 0; i < auditors.length; i++) {
                    const auditor = auditors[i];
                    auditor.Text = auditor.FirstName + " " + auditor.LastName;
                    auditor.Value = auditor.Id;
                }
                return auditors;
            })
    }

    function addNewAuditor(auditor) {
        vm.icdCorporationAuditors.push(auditor);
        vm.auditorComboBox.dataSource.read();
        vm.newAuditor = null;
        handleAuditorDataSourceRead();
    }

    function deleteAuditor(auditor) {
        vm.icdCorporationAuditors = vm.icdCorporationAuditors.filter(function (p) {
            return p.Id !== auditor.Id;
        });
        vm.auditorComboBox.dataSource.read();
        handleAuditorDataSourceRead();
    }

    function getCompanyLogo() {
        let icdCorporation = 0;
        if (vm.icdCorporationID) {
            icdCorporation = vm.icdCorporationID;
        }
        return icdCorporationService.retrieveIcdCompanyLogo(icdCorporation)
            .then(function (results) {
                const companyLogo: any = {};
                const file = new Blob([results.data], { type: results.data.type });
                companyLogo.file = file;

                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = function (e) {
                    $timeout(function () {
                        companyLogo.Url = e.target.result;
                    });
                }
                return companyLogo;
            });
    }

    function getHubs() {
        if (vm.hubOptions.length !== 0) {
            return $q.when(vm.hubOptions);
        }

        return hubService.retrieveHubs()
            .then(function (hubs) {
                for (let i = 0; i < hubs.length; i++) {
                    const hub = hubs[i];
                    hub.Text = hub.FirstName + " " + hub.LastName;
                }
                return hubs;
            })
            .catch(function (ex) {
                $log.warn("Hubs failed to load on EditIcdCorporation form.", getExceptionMessage(ex));
            });
    }

    function getPayrollInvoicePolicies() {
        return payrollInvoicePolicyService.retrievePayrollInvoicePolicies()
            .then(function (policies) {
                return policies;
            })
    }

    function loadIcdCorporation() {
        if (!vm.icdCorporationID) {
            vm.icdCorporation = {
                ShippingAddress: {},
                CompanyLogo: {},
                IcdCorporationStatusID: 1,
                Modules: [],
                Auditors: []
            };
            vm.payrollInvoicePolicyID = '';
        } else {
            return icdCorporationService.retrieveIcdCorporation(vm.icdCorporationID)
                .then(function (result) {
                    vm.icdCorporation = result;
                    vm.useHJFees = result.HasHJFees;
                    vm.ModuleOptions = vm.icdCorporation.Modules;
                    vm.icdtaxinfo = vm.icdCorporation.IcdCorporationTaxInfos;
                    if (vm.icdtaxinfo.length > 0) {
                        vm.icdtaxinfo.map(function (e) {
                            e.state = vm.stateProvinces.find(x => String(x.StateProvinceID) === e.State);
                            e.name = vm.icdtaxinfoTypes.find(x => x.Name === e.Name);
                            return e;
                        });
                    }
                    vm.payrollInvoicePolicyID = (vm.icdCorporation.PayrollInvoicePolicyID ? vm.icdCorporation.PayrollInvoicePolicyID : 0) || '';
                });
        }
    }

    function getIcdModules() {
        return icdCorporationService.retrieveIcdModules()
            .then(function (modules) {
                return modules;
            });
    }

    function getIcdCorporationStatus() {
        return icdCorporationService.retrieveIcdCorporationStatus()
            .then(function (statusOptions) {
                return statusOptions;
            });
    }

    function moduleToggleSelection(moduleId) {
        if (vm.ModuleOptions.indexOf(moduleId) > -1) {
            const index = vm.ModuleOptions.indexOf(moduleId);
            if (index > -1) {
                vm.ModuleOptions.splice(index, 1);
            }
        } else {
            vm.ModuleOptions.push(moduleId);
        }
    }

    function loadIcdOffices() {
        if (vm.icdCorporationID !== undefined && vm.icdCorporationID !== null) {
            const query = {
                IcdCorporationID: vm.icdCorporationID
            };
            return icdOfficeService.retrieveIcdOffices(query)
                .then(function (icdOffices) {
                    return icdOffices;
                });
        }
        return $q.when([]);
    }

    function onBeforeUnload() {
        if (vm.editForm && vm.editForm.$dirty) {
            return "Some changes might not have been saved.";
        }
    }
}
